import styled from 'styled-components';

import { ColorEnum } from '@enum/style/color.enum';

import PaginationIcon from './assets/pagination.icon.svg?react';

export const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

interface PaginationProps {
  isDisabled?: boolean;
}

export const NextIcon = styled(PaginationIcon)<PaginationProps>`
  fill: ${({ isDisabled = false }) => (isDisabled ? ColorEnum.Black30 : ColorEnum.Black100)};
`;

export const PrevIcon = styled(NextIcon)`
  transform: rotate(180deg);
`;
